
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/needs",
      function () {
        return require("private-next-pages/companies/needs/index.tsx");
      }
    ]);
  